let replaceURLWithHTMLLinks = (content, color) => {
	// 使用正则表达式匹配更广泛的URL格式(此正则由deepseek生成)
	const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|\bwww\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
	const linkColor = color || 'inherit';
	return content.replace(urlRegex, (url) => {
	    // 如果URL不以协议开头，则使用配置里的默认协议补齐
	    if (!url.startsWith("http")) {
	        url = process.env.VUE_APP_DEFAULT_URL_PROTOCOL + url;
	    }
	    return `<a href="${url}" target="_blank" style="color: ${linkColor};text-decoration: underline;">${url}</a>`;
	});
}

export default {
	replaceURLWithHTMLLinks
}
